import { Injectable } from '@angular/core';
import { INDRAfullConversation } from '@ibe.models/user.indra.model.lib';

@Injectable({
	providedIn: 'root'
})
export class INDRAStorageService {
	private currentSession: INDRAfullConversation = null;
	
	getCurrentSession(): INDRAfullConversation {
		return this.currentSession;
	}
	
	// getCurrentUser(): INDRAUserData {
	// 	const session: INDRASession = this.getCurrentSession();
	// 	return session && session.user ? session.user : null;
	// }
	
	isAuthenticated(): boolean {
		return this.getCurrentToken() != null ? true : false;
	}
	
	getCurrentToken(): string {
		const session = this.getCurrentSession();
		return session && session.sessionId ? session.sessionId : null;
	}
	
	set(key, value, local?: boolean) {
		try {
			if (local) {
				localStorage.setItem(key, JSON.stringify(value));
			} else {
				sessionStorage.setItem(key, JSON.stringify(value));
			}
		} catch (e) {
			if (local) {
				localStorage.removeItem(key);
				localStorage.setItem(key, JSON.stringify(value));
			} else {
				sessionStorage.removeItem(key);
				sessionStorage.setItem(key, JSON.stringify(value));
			}
		}
	}

	get(key, local?: boolean) {
		try {
			return local ? JSON.parse(localStorage.getItem(key)) : JSON.parse(sessionStorage.getItem(key));
		} catch (error) {
			return local ? localStorage.getItem(key) : sessionStorage.getItem(key);
		}
	}

	remove(key, local?: boolean) {
		if (local) {
			localStorage.removeItem(key);
		} else {
			sessionStorage.removeItem(key);
		}
	}

	removeAll(local?: boolean) {
		if (local) {
			localStorage.clear();
		} else {
			sessionStorage.clear();
		}
		
	}
	
	
}
